var axios = require('axios')
const urlRedeemGiftCard = process.env.version + '/product-giftcard/cards/{CARD_NUMBER}/redeem'

axios.checkGiftCard = function (params, success, callBackError) {
  this.post(urlRedeemGiftCard.replace('{CARD_NUMBER}', params.cardNumber), {
    amount: params.amount || 0,
    pin: params.cardPin || '',
    stage: 'VERIFY',
    store_code: params.storeCode || '9999',
    store_id: params.storeId || 1,
    cart: params.cart,
  }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.redeemGiftCard = function (params, success, callBackError) {
  this.post(urlRedeemGiftCard.replace('{CARD_NUMBER}', params.cardNumber), {
    amount: params.amount || 0,
    pin: params.cardPin || '',
    stage: 'COMMIT',
    store_code: params.storeCode,
    store_id: params.storeId,
    cart: params.cart,
  }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/Giftcard.js